import './scss/oneblock-config.scss';
import './assets/css/styles.css';
import initOneBlock from './assets/js/oneblock-init.mjs';
initOneBlock(false, true);